import React from 'react';

const Code = ({ width, height }) => {
  return (
    <div className=''>
      <svg
        className={`${width} ${height} hover:cursor-pointer`}
        fill='none'
        viewBox='0 0 24 24'
        stroke='currentColor'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4'
        />
      </svg>
    </div>
  );
};

export default Code;
